if (!customElements.get('free-shipping-progress')) {
  customElements.define(
    'free-shipping-progress',
    class FreeShippingProgress extends HTMLElement {
      constructor() {
        super();
        this.pendingRequest = null;
        this.refreshQueued = false;
        this.cartUpdateUnsubscriber = null;
      }

      connectedCallback() {
        this.threshold = Number(this.dataset.threshold || 10000);
        this.currency = this.dataset.currency || 'PLN';
        this.update(Number(this.dataset.total || 0), this.currency);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
      }

      async refresh() {
        if (this.pendingRequest) {
          this.refreshQueued = true;
          return this.pendingRequest;
        }

        this.refreshQueued = false;

        this.pendingRequest = fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => this.update(Number(cart.total_price || 0), cart.currency || this.currency))
          .catch(() => null)
          .finally(() => {
            this.pendingRequest = null;
            if (this.refreshQueued) this.refresh();
          });

        return this.pendingRequest;
      }

      update(total, currency) {
        if (currency !== 'PLN') {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        const remaining = Math.max(this.threshold - total, 0);
        const progress = Math.min(Math.max((total / this.threshold) * 100, 0), 100);
        const complete = remaining === 0;
        const formatter = new Intl.NumberFormat('pl-PL', {
          style: 'currency',
          currency: 'PLN',
          minimumFractionDigits: 2,
        });

        this.classList.toggle('is-complete', complete);
        this.style.setProperty('--free-shipping-progress', `${progress}%`);

        const icon = this.querySelector('[data-free-shipping-icon]');
        if (icon) icon.textContent = complete ? '✓' : '🚚';

        const remainingNode = this.querySelector('[data-free-shipping-remaining]');
        if (remainingNode) remainingNode.textContent = formatter.format(remaining / 100);

        const progressBar = this.querySelector('[role="progressbar"]');
        if (progressBar) {
          progressBar.setAttribute('aria-valuenow', String(Math.round(progress)));
          progressBar.setAttribute(
            'aria-label',
            complete
              ? 'Cel osiągnięty. Koszyk kwalifikuje się do darmowej dostawy.'
              : `Postęp do darmowej dostawy: ${Math.round(progress)} procent.`
          );
        }
      }
    }
  );
}
